import React, { useCallback, useEffect, useState } from 'react';

const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);
  const onScroll = useCallback(() => {
    const total = document.documentElement.scrollHeight - window.innerHeight;
    setProgress(total > 0 ? Math.min(100, (window.scrollY / total) * 100) : 0);
  }, [setProgress]);
  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-transparent pointer-events-none" data-testid="reading-progress">
      <div className="h-full bg-[#ff7300] transition-[width] duration-150" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ReadingProgress;
